<template>
  <div>
    <section class="content-header" style="height: 50px;">
      <a v-if="!$root.isCustomer" href="#" @click="$root.showNewBox" style="float: left; padding-right: 10px;"><i class="fa fa-plus-circle" style="font-size: 30px;"></i></a>
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
      <div action="#" method="get" class="sidebar-form" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div v-if="$root.isAdmin || $root.isDealer" class="col-sm-12" style="padding-left: 0px; background-color: #ddd; padding-bottom: 10px; border-radius: 5px;">
          <div class="col-sm-2" v-show="$root.isAdmin">
            <span>Select Dealer:</span>
            <select class="form-control" v-model="filters.dealerKey" style="padding-left: 0px;">
              <option value="All">All</option>
              <option v-for="(item,index) in $root.dealers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2" v-if="$root.isAdmin || $root.isDealer">
            <span>Select Customer:</span>
            <select class="form-control" v-model="filters.customerKey" style="padding-left: 0px;">
              <option value="All">All</option>
              <option v-for="(item,index) in customers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-success" value="Refresh" style="margin-top: 20px;" @click="reloadSites" />
          </div>
        </div>
        <VueTable :columns="columns" :rows="filteredItems" :info="infoIcons" @rowClick="rowClick"></VueTable>
      </div>
    </div>
    <AddSite></AddSite>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import VACheckBox from '../components/VACheckBox'
  import AddSite from '../components/AddSite'
  import VASelect from '../components/VASelect'
  import VAAlert from '../components/VAAlert.vue'
  import { db, dbListener } from '../firebase'
  export default {
    name: 'sites',
    components: { VueTable, 'va-alert': VAAlert, AddSite, 'va-checkbox': VACheckBox, 'va-select': VASelect },
    data () {
      return {
        sortBy: 'Name',
        sortDir: 'asc',
        filters: {
          dealerKey: '',
          customerKey: '',
          siteKey: ''
        },
        customers: [],
        sites: [],
        infoIcons: [
          { icon: 'fa fa-circle text-green', label: 'Online' },
          { icon: 'fa fa-circle text-red', label: 'Offline' },
          { icon: 'fa fa-circle text-orange', label: 'Unknown' }
        ],
        columns: [
          { fieldName: 'Status', label: '', isSortable: false, isHidden: false, isStatus: true, width: '20px' },
          // { fieldName: 'IsUSB', label: '', isSortable: false, isHidden: false, isStatus: true },
          { fieldName: 'Name', label: 'Site Name', isSortable: true, isHidden: false },
          { fieldName: 'CustomerName', label: 'Customer Name', isSortable: true, isHidden: false },
          { fieldName: 'DealerName', label: 'Dealer Name', isSortable: true, isHidden: false },
          { fieldName: 'ComputerName', label: 'Computer Name', isSortable: true, isHidden: false },
          { fieldName: 'Address', label: 'Address', isSortable: true, isHidden: false },
          // { fieldName: 'TotalPrinters', label: 'Total Printers', isSortable: true, isHidden: false },
          { fieldName: 'PrevVersion', label: 'Prev. Version', isSortable: true, isHidden: false },
          { fieldName: 'PrinterCounterVersion', label: 'Client Version', isSortable: true, isHidden: false },
          { fieldName: 'InstallDate', label: 'Install Date', isSortable: true, isHidden: false },
          { fieldName: 'UninstallDate', label: 'Uninstall Date', isSortable: true, isHidden: false },
          { fieldName: 'LastRun', label: 'Last Run', isSortable: true, isHidden: false },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'RestartClient', fieldName: 'IsRestart', label: 'Restart Client', iconClass: 'fa fa-power-off' },
              { name: 'RefreshSite', fieldName: 'IsRefresh', label: 'Refresh Site', iconClass: 'fa fa-refresh', color: '#3c8dbc' },
              { name: 'InfoSite', label: 'Upload Site Log', iconClass: 'fa fa-exclamation-triangle iconWarning iconSize' },
              { name: 'Edit', label: 'Edit', iconClass: 'fa fa-edit', color: 'green' },
              { name: 'Delete', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'red' }
            ]
          }
        ],
        refreshSitesList: [],
        timer: null
      }
    },
    watch: {
      'filters.dealerKey' (val) {
        this.filters.customerKey = 'All'
        if (val === 'All') {
          this.customers = []
          // this.loadCustomers()
        } else {
          this.loadCustomers()
        }
      }
    },
    created () {
      this.$root.title = 'Sites'
      if (this.$root.isAdmin) {
        if (this.$root.userHistory) {
          this.filters.dealerKey = this.$root.userHistory.selectedDealer
          this.filters.customerKey = this.$root.userHistory.selectedCustomer
          this.filters.siteKey = this.$root.userHistory.selectedSite
        } else {
          this.filters.dealerKey = 'All'
          this.filters.customerKey = 'All'
          this.filters.siteKey = 'All'
        }
      } else if (this.$root.isDealer) {
        // this.filters.dealerKey = this.$root.user['.key']
      } else if (this.$root.isCustomer) {
        this.filters.dealerKey = this.$root.filter.dealerKey
        this.filters.customerKey = this.$root.filter.customerKey
        let index = this.columns.findIndex(c => c.fieldName === 'VueBottons')
        if (index > -1) {
          this.columns.splice(index, 1)
        }
        this.loadCustomers()
        this.reloadSites()
      }
    },
    mounted () {
      console.log('Sites mounted...')
      this.filters.customerKey = this.$route.params.customerKey
      if (this.$root.isDealer || this.$root.isCustomer) {
        this.filters.dealerKey = this.$root.filter.dealerKey
      }
    },
    updated () {
      console.log('Sites updated...')
      // this.loadSites()
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.sites.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.sites
        }
        return result
      }
    },
    methods: {
      loadCustomers () {
        console.log('loadCustomers...')
        this.customers = []
        for (let i = 0; i < this.$root.customers.length; i++) {
          if (this.$root.customers[i].dealerKey === this.filters.dealerKey) {
            this.customers.push(this.$root.customers[i])
          }
        }
      },
      reloadSites () {
        console.log('reloadSites...')
        if (this.filters.dealerKey === 'All') {
          this.loadAllSites()
        } else {
          if (this.filters.customerKey === 'All') {
            this.loadDealerSites()
          } else {
            this.loadCustomerSites()
          }
        }
      },
      loadAllSites () {
        console.log('loadAllSites...')
        const vm = this
        vm.sites = []
        for (let s = 0; s < vm.$root.dealers.length; s++) {
          let dealerKey = vm.$root.dealers[s].value
          let dealerName = vm.$root.dealers[s].title
          db.ref('Dealers/' + vm.$root.dealers[s].value + '/Customers').once('value').then(function (snapItems) {
            const data = snapItems.val()
            if (data) {
              const custKeys = Object.keys(data)
              for (let i = 0; i < custKeys.length; i++) {
                let custKey = custKeys[i]
                let customer = data[custKey]
                if (customer) {
                  customer['.key'] = custKey
                  if (customer.Sites) {
                    let sites = customer.Sites
                    const siteKeys = Object.keys(sites)
                    for (let j = 0; j < siteKeys.length; j++) {
                      let siteKey = siteKeys[j]
                      let site = sites[siteKey]
                      console.log(site)
                      site['.key'] = siteKey
                      site['DealerKey'] = dealerKey
                      site['DealerName'] = dealerName
                      site['CustomerKey'] = custKey
                      site['CustomerName'] = customer.Name
                      site['ComputerName'] = site.ClientInfo ? site.ClientInfo.ComputerName : ''
                      site['PrinterCounterVersion'] = site.ClientInfo ? site.ClientInfo.PrinterCounterVersion : ''
                      site['PrinterCounterVersion'] = site['PrinterCounterVersion'].replace('PrinterCounters', '')
                      site['InstallDate'] = site.ClientInfo ? site.ClientInfo.Time : ''
                      site['UninstallDate'] = site.ClientUninstall ? site.ClientUninstall.Time : ''
                      site.Status = site.Status ? site.Status : 'Unknown'
                      site['IsRestart'] = site.IsRestart ? site.IsRestart : 'Running'
                      site.IsUSB = (site.ClientInfo && site.ClientInfo.IsUSB === 'true')
                      vm.sites.push(site)
                    }
                  }
                }
              }
            }
          })
        }
      },
      loadDealerSites () {
        console.log('loadDealerSites...')
        const vm = this
        let dealerName = ''
        for (let d = 0; d < vm.$root.dealers.length; d++) {
          if (vm.$root.dealers[d].value === vm.filters.dealerKey) {
            dealerName = vm.$root.dealers[d].title
            break
          }
        }
        const sitesPath = 'Dealers/' + vm.filters.dealerKey + '/Customers'
        const sitesRef = db.ref(sitesPath)
        vm.sites = []
        sitesRef.once('value').then(function (snapItems) {
        // sitesRef.on('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            // console.log(data)
            const custKeys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < custKeys.length; i++) {
              let custKey = custKeys[i]
              let customer = data[custKey]
              if (customer) {
                customer['.key'] = custKey
                if (customer.Sites) {
                  let sites = customer.Sites
                  const siteKeys = Object.keys(sites)
                  for (let j = 0; j < siteKeys.length; j++) {
                    let siteKey = siteKeys[j]
                    let site = sites[siteKey]
                    console.log(site)
                    site['.key'] = siteKey
                    site['DealerKey'] = vm.filters.dealerKey
                    site['DealerName'] = dealerName
                    site['CustomerKey'] = custKey
                    site['CustomerName'] = customer.Name
                    site['ComputerName'] = site.ClientInfo ? site.ClientInfo.ComputerName : ''
                    site['PrinterCounterVersion'] = site.ClientInfo ? site.ClientInfo.PrinterCounterVersion : ''
                    site['PrinterCounterVersion'] = site['PrinterCounterVersion'].replace('PrinterCounters', '')
                    site['InstallDate'] = site.ClientInfo ? site.ClientInfo.Time : ''
                    site['UninstallDate'] = site.ClientUninstall ? site.ClientUninstall.Time : ''
                    site.Status = site.Status ? site.Status : 'Unknown'
                    site['IsRestart'] = site.IsRestart ? site.IsRestart : 'Running'
                    site.IsUSB = (site.ClientInfo && site.ClientInfo.IsUSB === 'true')
                    vm.sites.push(site)
                  }
                }
              }
            }
          }
        })
      },
      loadCustomerSites () {
        console.log('loadCustomerSites...')
        const vm = this
        const sitesPath = 'Dealers/' + vm.filters.dealerKey + '/Customers/' + vm.filters.customerKey + '/Sites'
        const sitesRef = db.ref(sitesPath)
        vm.sites = []
        let customerName = ''
        let dealerName = ''
        // vm.customers
        for (let c = 0; c < vm.customers.length; c++) {
          if (vm.customers[c].value === vm.filters.customerKey) {
            customerName = vm.customers[c].title
            break
          }
        }
        for (let d = 0; d < vm.$root.dealers.length; d++) {
          if (vm.$root.dealers[d].value === vm.filters.dealerKey) {
            dealerName = vm.$root.dealers[d].title
            break
          }
        }
        // sitesRef.once('value').then(function (snapItems) {
        sitesRef.once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            console.log(data)
            const keys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let site = data[key]
              console.log(site)
              site['.key'] = key
              // site['customerKey'] = vm.filters.customerKey
              site['DealerKey'] = vm.filters.dealerKey
              site['DealerName'] = dealerName
              site['CustomerKey'] = vm.filters.customerKey
              site['CustomerName'] = customerName
              site['ComputerName'] = site.ClientInfo ? site.ClientInfo.ComputerName : ''
              site['PrinterCounterVersion'] = site.ClientInfo ? site.ClientInfo.PrinterCounterVersion : ''
              site['PrinterCounterVersion'] = site['PrinterCounterVersion'].replace('PrinterCounters', '')
              site['InstallDate'] = site.ClientInfo ? site.ClientInfo.Time : ''
              site['UninstallDate'] = site.ClientUninstall ? site.ClientUninstall.Time : ''
              site.Status = site.Status ? site.Status : 'Unknown'
              site['IsRestart'] = site.IsRestart ? site.IsRestart : 'Running'
              site.IsUSB = (site.ClientInfo && site.ClientInfo.IsUSB === 'true')
              vm.sites.push(site)
            }
          }
        })
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'RestartClient': this.restartClient(item); break
          case 'RefreshSite': this.refreshSite(item); break
          case 'InfoSite': this.infoSite(item); break
          case 'Edit': this.edit(item); break
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      restartClient (item) {
        console.log('restartClient(' + item['.key'] + ')')
        if (item.IsRestart === 'Running') {
          item.IsRestart = 'Restart'
          dbListener.ref('ClientRestart/Restarter/' + item['.key'] + '/Status').set('Restart')
        }
      },
      refreshSite (item) {
        let vm = this
        // this.$bus.$emit('siteModal-open', item)
        if (item.IsRefresh === 'Ready') {
          item.IsRefresh = 'Refresh'
          db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Refresh')
          dbListener.ref('RefreshPrinter/' + item.SiteKey + '/' + item.MacAddress).set(true)
        }
        console.log('Get site signal ...')
        console.log('item.Name = ' + item.Name)
        console.log('item.Key = ' + item['.key'])
        dbListener.ref('UpdateClient/' + item['.key'] + '/ReadSignal').set(true)
        vm.refreshSitesList.push({ SiteKey: item['.key'], Time: vm.$moment().format('YYYY-MM-DD HH:mm:ss') })
        if (vm.timer === null) {
          vm.timer = setInterval(vm.resetRefreshSites(item['.key']), (1000 * 5)) // 5 sec
        }
      },
      resetRefreshSites (siteKey) {
        let vm = this
        console.log('resetRefreshSites()...')
        let clearIndexs = []
        if (vm.refreshSitesList.length > 0) {
          for (let i = 0; i < vm.refreshSitesList.length; i++) {
            if (vm.refreshSitesList[i].MAC && vm.refreshSitesList[i].Time) {
              var now = vm.$moment()
              var refreshTime = vm.$moment(vm.refreshSitesList[i].Time, 'YYYY-MM-DD HH:mm:ss')
              let diffTime = now.diff(refreshTime, 'seconds')
              if (diffTime >= 5) {
                dbListener.ref('UpdateClient/' + siteKey + '/ReadSignal').set(false)
                db.ref('Printers/' + vm.refreshSitesList[i].MAC + '/IsRefresh').set('Ready')
                vm.refreshSitesList[i].SiteKey = null
                vm.refreshSitesList[i].Time = null
                clearIndexs.push(i)
              }
            }
          }
          for (let i = 0; i < clearIndexs.length; i++) {
            vm.refreshSitesList.splice(i, 1)
          }
        } else {
          clearInterval(vm.timer)
          vm.timer = null
        }
      },
      refreshPrinter (item) {
        console.log(item)
        // let vm = this
        if (item.IsRefresh === 'Ready') {
          item.IsRefresh = 'Refresh'
          db.ref('Printers/' + item.MacAddress + '/IsRefresh').set('Refresh')
          dbListener.ref('RefreshPrinter/' + item.SiteKey + '/' + item.MacAddress).set(true)
        }
      },
      infoSite (item) {
        // this.$bus.$emit('siteModal-open', item)
        console.log('Get log files from site ...')
        console.log('item.Name = ' + item.Name)
        console.log('item.Key = ' + item['.key'])
        dbListener.ref('UpdateClient/' + item['.key'] + '/GetLog').set(true)
      },
      edit (item) {
        this.$bus.$emit('siteModal-open', item)
      },
      confirmDelete (item) {
        const vm = this

        vm.$bus.$emit('modal-open', {
          title: 'Delete Site',
          description: 'Are you sure you want to delete site [' + item.Name + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            const siteRef = db.ref('Dealers/' + item.DealerKey + '/Customers/' + item.CustomerKey + '/Sites/' + item['.key'])
            siteRef.remove()

            db.ref('Dealers/' + item.DealerKey + '/TotalSites').once('value').then(function (snapTotalSites) {
              let totalSites = snapTotalSites.val()
              db.ref('Dealers/' + item.DealerKey + '/TotalSites').set(totalSites - 1)
            })

            let customerTotalSitesPth = 'Dealers/' + item.DealerKey + '/Customers/' + item.CustomerKey + '/TotalSites'
            db.ref(customerTotalSitesPth).once('value').then(function (snapTotalSites) {
              let totalSites = snapTotalSites.val()
              db.ref(customerTotalSitesPth).set(totalSites - 1)
            })
            vm.reloadSites()
            // vm.$root.loadSlideItems()
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }
    }
  }
</script>
<style>
  .iconBlack {
    color: black;
    font-size: 14px;
  }
  .iconGray {
    color: #aaa;
    font-size: 14px;
  }
  .iconSize {
    font-size: 20px!important;
  }
</style>




// WEBPACK FOOTER //
// Sites.vue?1f97906c